import { render } from "./PageLoading.vue?vue&type=template&id=5bfbaade&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"

import "./PageLoading.vue?vue&type=style&index=0&id=5bfbaade&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bfbaade"

export default script